import { Fragment, lazy, Suspense } from 'react';
import ContainerSkeleton from '../../components/Common/Skeleton/Container';
const AdminDisputeDetails = lazy(() => import('../../components/Admin/AdminDisputeDetails'));

const AdminDisputePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<ContainerSkeleton />}>
        <AdminDisputeDetails />
      </Suspense>
    </Fragment>
  );
};

export default AdminDisputePage;
